import { useEffect, type ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { useIsMobile } from '@/hooks/use-media-query';
import { cn } from '@/lib/utils/cn';
import { useUiStore } from '@/store/ui.store';

import { NavigationBar } from './navigation-bar';
import { TopNav } from './top-nav';

/**
 * Authenticated shell: planning-v2–style sidebar, top bar, and main content.
 */
export function AppLayout(): ReactElement {
  const isMobile = useIsMobile();
  const sidebarOpen = useUiStore((s) => s.sidebarOpen);
  const setIsMobile = useUiStore((s) => s.setIsMobile);
  const setSidebarOpen = useUiStore((s) => s.setSidebarOpen);

  useEffect(() => {
    setIsMobile(isMobile);
  }, [isMobile, setIsMobile]);

  const handleCloseSidebar = (): void => {
    setSidebarOpen(false);
  };

  return (
    <div
      className="h-screen overflow-hidden bg-background"
      style={{ ['--topnav-height' as string]: '68px' }}
    >
      <NavigationBar isOpen={isMobile ? sidebarOpen : true} onClose={handleCloseSidebar} />
      <TopNav />
      <main
        className={cn(
          'flex h-screen min-h-0 flex-col overflow-hidden pt-[var(--topnav-height)] transition-all duration-500 ease-in-out',
          !isMobile ? 'ml-[60px]' : ''
        )}
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
      </main>
    </div>
  );
}